module.exports = __webpack_public_path__ + "static/media/纸质游戏手柄.1422fbe7.png";